import React from "react";
import "./MainButton.css";

export default function MainButton(props) {
  return (
    <>
      <button className="button-nice">
        <a href={props.buttonHref} rel="noreferrer" target="_blank">
          {props.callToAction}
        </a>
      </button>
    </>
  );
}
